export const REQUEST_USER_DATA = 'REQUEST_USER_DATA';
export const RECEIVE_USER_DATA = 'RECEIVE_USER_DATA';
export const FAILURE_USER_DATA = 'FAILURE_USER_DATA';
export const SET_USER_DATA = 'SET_USER_DATA';

export const SET_MAIN_DATA = 'SET_MAIN_DATA';
export const SET_MAIN_DATA_CHILD = 'SET_MAIN_DATA_CHILD';
export const CHANGE_MAIN_DATA = 'CHANGE_MAIN_DATA';
export const CHANGE_MAIN_DATA_CHILD = 'CHANGE_MAIN_DATA_CHILD';
export const BLUR_MAIN_DATA = 'BLUR_MAIN_DATA';
export const BLUR_MAIN_DATA_CHILD = 'BLUR_MAIN_DATA_CHILD';

export const SET_PASSPORT_DATA = 'SET_PASSPORT_DATA';
export const SET_PASSPORT_DATA_CHILD = 'SET_PASSPORT_DATA_CHILD';
export const CHANGE_PASSPORT_DATA = 'CHANGE_PASSPORT_DATA';
export const CHANGE_PASSPORT_DATA_CHILD = 'CHANGE_PASSPORT_DATA_CHILD';
export const BLUR_PASSPORT_DATA = 'BLUR_PASSPORT_DATA';
export const BLUR_PASSPORT_DATA_CHILD = 'BLUR_PASSPORT_DATA_CHILD';
export const CHANGE_DOCUMENT_TYPE = 'CHANGE_DOCUMENT_TYPE';
export const CHANGE_DOCUMENT_TYPE_CHILD = 'CHANGE_DOCUMENT_TYPE_CHILD';

export const SET_ACT_RECORD_DATA = 'SET_ACT_RECORD_DATA';
export const CHANGE_ACT_RECORD_DATA = 'CHANGE_ACT_RECORD_DATA';
export const BLUR_ACT_RECORD_DATA = 'BLUR_ACT_RECORD_DATA';
export const RESET_ACT_RECORD_DATA = 'RESET_ACT_RECORD_DATA';
export const GET_REG_PLACE_SUGGESTIONS = 'GET_REG_PLACE_SUGGESTIONS';
export const GET_REG_PLACE_SUGGESTIONS_SUCCESS =
  'GET_REG_PLACE_SUGGESTIONS_SUCCESS';
export const GET_REG_PLACE_SUGGESTIONS_ERROR =
  'GET_REG_PLACE_SUGGESTIONS_ERROR';

export const REQUEST_EXAM_DATA = 'REQUEST_EXAM_DATA';
export const RECEIVE_EXAM_DATA = 'RECEIVE_EXAM_DATA';
export const FAILURE_EXAM_DATA = 'FAILURE_EXAM_DATA';
export const INVALID_EXAM_ATTRIBUTES = 'INVALID_EXAM_ATTRIBUTES';
export const RESULT_NOT_READY = 'RESULT_NOT_READY';

export const CHANGE_EXAM = 'CHANGE_EXAM';
export const CHANGE_STEP = 'CHANGE_STEP';
export const SET_COMPLETE_STEP = 'SET_COMPLETE_STEP';

export const APPROVE_EXAM = 'APPROVE_EXAM';
export const AGREE = 'AGREE';
export const SET_CHAT_INTERVAL = 'SET_CHAT_INTERVAL';
export const SHOW_APPROVE = 'SHOW_APPROVE';
export const CLOSE_SUCCESS = 'CLOSE_SUCCESS';

export const UPDATE_APPEAL_DATA = 'UPDATE_APPEAL_DATA';
export const TOGGLE_EXAM_SHOW_ONLY_INCORRECT =
  'TOGGLE_EXAM_SHOW_ONLY_INCORRECT';

export const REQUEST_ERROR_HIDE = 'REQUEST_ERROR_HIDE';

export const CHANGE_APPLICANT_TYPE = 'CHANGE_APPLICANT_TYPE';
export const SELECT_CHILD = 'SELECT_CHILD';

// отправка заявления на несоответсвие бланков
export const NOT_CORRECT_EXAM_FORM_SHOW = 'NOT_CORRECT_EXAM_FORM_SHOW';
export const NOT_CORRECT_EXAM_FORM_HIDE = 'NOT_CORRECT_EXAM_FORM_HIDE';
export const NOT_CORRECT_EXAM_FORM_CHANGE = 'NOT_CORRECT_EXAM_FORM_CHANGE';
export const NOT_CORRECT_EXAM_FORM_SET_INVALID =
  'NOT_CORRECT_EXAM_FORM_SET_INVALID';

export const NOT_CORRECT_EXAM_FORM_SUBMIT = 'NOT_CORRECT_EXAM_FORM_SUBMIT';
export const NOT_CORRECT_EXAM_FORM_SUBMIT_SUCCESS =
  'NOT_CORRECT_EXAM_FORM_SUBMIT_SUCCESS';
export const NOT_CORRECT_EXAM_FORM_SUBMIT_ERROR =
  'NOT_CORRECT_EXAM_FORM_SUBMIT_ERROR';
export const NOT_CORRECT_EXAM_FORM_SUBMIT_ALREADY_REPORTED =
  'NOT_CORRECT_EXAM_FORM_SUBMIT_ALREADY_REPORTED';

// отправка апелляции
export const REQUEST_APPEAL_SUBMIT = 'REQUEST_APPEAL_SUBMIT';
export const REQUEST_APPEAL_SUCCESS = 'REQUEST_APPEAL_SUCCESS';
export const REQUEST_APPEAL_ERROR = 'REQUEST_APPEAL_ERROR';
export const REQUEST_APPEAL_ALREADY_REPORTED =
  'REQUEST_APPEAL_ALREADY_REPORTED';

// отмена апелляции
export const APPEAL_CANCEL_REQUEST = 'APPEAL_CANCEL_REQUEST';
export const APPEAL_CANCEL_SUCCESS = 'APPEAL_CANCEL_SUCCESS';
export const APPEAL_CANCEL_ERROR = 'APPEAL_CANCEL_ERROR';
export const APPEAL_CANCEL_ALREADY_REPORTED = 'APPEAL_CANCEL_ALREADY_REPORTED';
export const APPEAL_CANCEL_RESET = 'APPEAL_CANCEL_RESET';

// константы редьюсера GIA
export const SET_GIA_ITEMS = 'SET_GIA_ITEMS';
export const CHANGE_GIA_ITEM = 'CHANGE_GIA_ITEM';
export const BLUR_GIA_ITEM = 'BLUR_GIA_ITEM';

export const SET_EXAMS_AVAILABILITY = 'SET_EXAMS_AVAILABILITY';

// поиск уже поданной апелляции
export const FIND_APPEAL = 'FIND_APPEAL';
export const FIND_APPEAL_SUCCESS = 'FIND_APPEAL_SUCCESS';
export const FIND_APPEAL_ERROR = 'FIND_APPEAL_ERROR';
export const RESET_APPEAL = 'RESET_APPEAL';

// черновик
export const LOAD_DRAFT = 'LOAD_DRAFT';
export const LOAD_DRAFT_EMPTY = 'LOAD_DRAFT_EMPTY';
export const LOAD_DRAFT_SUCCESS = 'LOAD_DRAFT_SUCCESS';
export const LOAD_DRAFT_ERROR = 'LOAD_DRAFT_ERROR';
export const REPLACE_DRAFT_STATE = 'REPLACE_DRAFT_STATE';
export const SAVE_DRAFT = 'SAVE_DRAFT';
export const SAVE_DRAFT_SUCCESS = 'SAVE_DRAFT_SUCCESS';
export const SAVE_DRAFT_ERROR = 'SAVE_DRAFT_ERROR';
export const DELETE_DRAFT = 'DELETE_DRAFT';
export const DELETE_DRAFT_SUCCESS = 'DELETE_DRAFT_SUCCESS';
export const DELETE_DRAFT_ERROR = 'DELETE_DRAFT_ERROR';
export const DRAFTS_NOT_LOADED = 'DRAFTS_NOT_LOADED';

// избранное
export const LOAD_SERVICE_FAVORITE_STATUS = 'LOAD_SERVICE_FAVORITE_STATUS';
export const LOAD_SERVICE_FAVORITE_STATUS_SUCCESS =
  'LOAD_SERVICE_FAVORITE_STATUS_SUCCESS';
export const CHANGE_SERVICE_FAVORITE_STATUS = 'CHANGE_SERVICE_FAVORITE_STATUS';
export const CHANGE_SERVICE_FAVORITE_STATUS_SUCCESS =
  'CHANGE_SERVICE_FAVORITE_STATUS_SUCCESS';

export const USER_CHANGED_MODAL_OPEN = 'USER_CHANGED_MODAL_OPEN';
export const USER_CHANGED_MODAL_CLOSE = 'USER_CHANGED_MODAL_CLOSE';
